/* eslint-disable react/react-in-jsx-scope */
import { File, Folder, Tree } from "@/components/extension/tree-view-api-doc";
import {
  buildDocumentTree,
  DocumentRecord,
  DocumentTreeNode,
} from "@/documents/utils/documentTree";
import { useFetchDataV2 } from "@/hooks/useFetchDataV2";
import { FolderIcon } from "lucide-react";
import { TreeRoot } from "@/types";
import { useParams, useSearchParams } from "react-router-dom";

const TreeViewDocument = () => {
  const { firstname } = useParams();
  const [searchParams] = useSearchParams();
  const { data: documentsData } = useFetchDataV2<Record<string, DocumentRecord[]>>(
    `${import.meta.env.VITE_API_ENDPOINT}/docs/financer`,
  );
  const { data: financerTree } = useFetchDataV2<TreeRoot[]>(
    `${import.meta.env.VITE_API_ENDPOINT}/tree/financer`,
  );

  if (!firstname) {
    return null;
  }

  const nodes = buildDocumentTree({
    firstname,
    documentsData,
    carrierTree: financerTree,
  });

  const currentEntries = [...searchParams.entries()].sort();

  const isSelected = (url?: string) => {
    if (!url) return false;
    const [, query = ""] = url.split("?");
    const targetEntries = [...new URLSearchParams(query).entries()].sort();
    return JSON.stringify(targetEntries) === JSON.stringify(currentEntries);
  };

  const renderNodes = (items: DocumentTreeNode[]) =>
    items.map((item) => {
      if (item.children && item.children.length > 0) {
        return (
          <Folder
            key={item.id}
            element={item.label}
            value={item.id}
            visibleChevron={true}
            url={item.url}
            isSelect={isSelected(item.url)}
          >
            {renderNodes(item.children)}
          </Folder>
        );
      }

      return (
        <File
          key={item.id}
          value={item.id}
          className="py-1 ml-3"
          fileIcon={<FolderIcon size={18} className="text-muted-foreground" />}
          title={item.label}
          isSelectable={true}
          isSelect={isSelected(item.url)}
          url={item.url ?? `/${firstname}/mes-documents`}
        >
          <span className="w-full truncate flex-1 text-muted-foreground">
            {item.label}
          </span>
        </File>
      );
    });

  return (
    <Tree
      initialSelectedId="doc-parent"
      elements={[{ id: "doc-parent", name: "Mes documents", isSelectable: true }]}
      className="mb-4"
      id="Mes documents"
    >
      <Folder element="Mes documents" value="doc-parent" visibleChevron={true}>
        <div className="flex flex-col gap-1">{renderNodes(nodes)}</div>
      </Folder>
    </Tree>
  );
};

export default TreeViewDocument;
